import React, { memo } from "react";
import { useSelector } from "react-redux";

import Loader from "../../Common/Loader";
import CustomerTable from "./Table";
import Filter from "./Filter";
import Divider from "./../../Common/Divider";
import NotFound from "../../Common/NotFound";

const Display = memo(() => {
	const customers = useSelector(state => state.customers);
	const isLoading = useSelector(state => state.loader);
	const searchLimitReached = customers && customers.length >= 50;

	return (
		<>
			<Filter />
			<Divider />
			{   //Customers set to null is the starting state for the store
				//Meaning no filter has yet happened, so we inform the NMSC what to do
				isLoading ? (
					<Loader />
				) : customers === null ? (
					<span>
						Please use the filters above to find a customer. You have to filter on at least one field but we
						recommend filling in as much details as possible for the search to be more specific.
					    <br />
						<br />
						Requirements:
					    <ul className="dotted-list">
							<li>First name and last name need to have a minimum of 3 characters</li>
							<li>
								The search on first and last name will be a starts with filter.
								i.e. &quot;Johnathan&quot;
								can be found using &quot;Joh&quot;
						    </li>
							<li>
								Email search has to be <u>exact</u>
							</li>
							<li>
								A maximum of 50 results will show on this page,
								if the search delivers more than 50 results,
								please specify your search better.
						    </li>
						</ul>
					</span>
				) : customers && customers.length ? (
				    <>
                        {
                            searchLimitReached ? ( <span>
                                    Results are limited to 50 entries. Please enter more specific search criteria.
                            </span> )
                                : ( <></> )
                        }
                        <CustomerTable customers={customers} />
                    </>
				) : (
                    <NotFound>The filter returned no matching customers...</NotFound>
                )}
		</>
	);
});
Display.displayName = `Display`;
export default Display;
